module.exports = __webpack_public_path__ + "static/media/pulmonology-image-1@2x.83b943f2.png";